module.exports = __webpack_public_path__ + "static/img/lbil-luanch-thumb.d941b6fa.jpg";